class HeaderOverlay {
	/**
	 * @param {HTMLElement} element
	 * @param {Function} callback
	 */
	constructor(element, callback) {
		this.element = element.querySelector(".HeaderOverlay");
		this.state = {
			open: false,
		};
		this.callback = callback;

		const linkElement = this.element.querySelector("a.HeaderOverlay-toggle");
		const template = this.element.querySelector("template");

		if (linkElement && template) {
			this.button = template.content?.firstElementChild?.cloneNode(true);

			if (this.button) {
				const closeButton = this.element.querySelector(
					".HeaderOverlay-toggle--close",
				);

				linkElement.replaceWith(this.button);

				this.button.addEventListener("click", this.#onClick.bind(this));

				template.remove();

				if (closeButton) {
					closeButton.remove();
				}
			}
		}

		this.element.dataset.js = true;
	}

	/**
	 * @returns {void}
	 */
	#onClick() {
		if (this.state.open) {
			this.state.open = false;
		} else {
			this.state.open = true;
		}

		this.#render();
		this.onToggle(this.state.open);
	}

	/**
	 * Render overlay
	 */
	#render() {
		if (this.state.open) {
			this.button.setAttribute("aria-expanded", "true");
		} else {
			this.button.setAttribute("aria-expanded", "false");
		}
	}

	/**
	 * Show overlay
	 */
	show() {
		this.state.open = true;
		this.#render();
	}

	/**
	 * Hide overlay
	 */
	hide() {
		this.state.open = false;
		this.#render();
	}
}

export default HeaderOverlay;
